import {useContext, useEffect, useState} from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import {Badge, Container, Tab, Tabs} from "react-bootstrap";
import API, {HandleError} from "../API";
import AppContext from "../AppContext";
import {useSnackbar} from "notistack";
import './Account.scss';
import OrdersTable from "../components/OrdersTable";
import {GoInfo} from "react-icons/go";
import {Order} from "../models/Order";
import {BiUser} from "react-icons/bi";
import AccountForm from "../components/AccountForm";
import {User} from "../models/User";
import AccountSubscriptions from "../components/AccountSubscriptions";
import {MdOutlineSubscriptions} from "react-icons/md";
import {useTranslation} from "react-i18next";
import {Trans} from "react-i18next/icu.macro";

export default function Account() {
    const app = useContext(AppContext)
    const { t, i18n } = useTranslation();
    const { enqueueSnackbar } = useSnackbar()
    const [tab, setTab] = useState(window.location.hash.substring(1))
    const [userInfo, setUserInfo] = useState({
        first_name: '',
        last_name: '',
        email: '',
        level: 1,
        points: 0
    })

    const [orders, setOrders] = useState([])
    const handleHashChange = (e) => {
        setTab(window.location.hash.substring(1))
    }
    useEffect(() => {
        app.startLoading()
        getAccountInfo()
    }, [])
    useEffect( ()=> {
        window.addEventListener("hashchange", handleHashChange);
        return () => {
            window.removeEventListener("hashchange", handleHashChange);
        }
    }, [])


    const getAccountInfo = async () => {
        app.startLoading()
        try {
            const res = await API({
                method: 'GET',
                url: '/account',
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                },
                data: {}
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;

            app.stopLoading()

            setUserInfo({...userInfo,
                first_name: res.data.user.first_name,
                last_name: res.data.user.last_name,
                email: res.data.user.email,
                level: res.data.user.level,
                points: res.data.user.points
            })
            app.setUser(new User(res.data.user))
            setOrders(res.data.orders.map((order, idx) => new Order(order)))
        }
        catch(e) {
            app.stopLoading()
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }

    const handleTabSelect = (key) => {
        if(!key)
            return;

        setTab(key)
        window.location.hash = '#' + key
    }

    return <div id="page-library" className={"page " + (app.ui.isDrawerOpen ? 'menu-shown' : '')}>
        <Sidebar />
        <div className="page-inner">
            <Header />
            <Container fluid className="pt-4">
                <h2 className="mb-4"><Trans i18nKey={'profile.greeting'} values={{ name: app.user.first_name }} /></h2>
                <Tabs
                    activeKey={tab ? tab : 'profile'}
                    id="account-tabs"
                    onSelect={handleTabSelect}
                >
                    <Tab eventKey="profile" title={t('accountTabs.profile')}>
                        <h3 className="mb-4">{t('profile.title')}</h3>
                        <p className="tab-info mb-4 text-muted" >
                            <BiUser /> {t('profile.subtitle')}
                        </p>
                        <AccountForm />
                    </Tab>
                    <Tab eventKey="subscriptions" title={t('accountTabs.orders')}>
                        <h3 className="mb-4">{t('orders.title')}</h3>
                        <p className="tab-info mb-4 text-muted" >
                            <MdOutlineSubscriptions /> {t('orders.subtitle')}
                        </p>
                        <AccountSubscriptions />
                    </Tab>
                    <Tab eventKey="orders" title={<span>{t('accountTabs.payments')} {(app.user && app.user?.pending_orders > 0 ? <Badge bg="info" className="ms-2">{app.user.pending_orders}</Badge> : null)}</span>}>
                        <h3 className="mb-4">{t('paymentHistory.title')}</h3>
                        <p className="tab-info mb-4 text-muted">
                            <GoInfo /> {t('paymentHistory.subtitle')}
                        </p>
                        <OrdersTable orders={orders} setOrders={setOrders} />
                    </Tab>
                </Tabs>
            </Container>
        </div>
    </div>
}